// Pull one of the user's own cloud samples into the local IDB-backed
// library so it's playable via `s("<name>")`. Companion to
// importCommunitySample — same plumbing, different provenance label.
//
// The asymmetry this addresses: samples uploaded via the MCP server
// land in Supabase + R2 directly, never touching this device's IDB.
// The MINE/Cloud rail tab lists those rows; clicking import is what
// brings them onto this device.

import { importCloudBlobToLocal } from './importCloudBlob';
import type { SampleStorage } from '../samples/storage/idb';
import type { Sample } from '../samples/types';
import type { MyCloudSample } from './listMySamples';

export type ImportMyCloudResult = {
  sample: Sample;
};

export async function importMyCloudSample(
  cloud: MyCloudSample,
  ctx: AudioContext,
  storage: SampleStorage,
): Promise<ImportMyCloudResult> {
  return importCloudBlobToLocal({
    source: {
      id: cloud.id,
      name: cloud.name,
      durationMs: cloud.durationMs,
      tags: cloud.tags,
      license: cloud.license,
      r2Key: cloud.r2Key,
    },
    filenameOrigin: `mine:${cloud.id}`,
    ctx,
    storage,
  });
}
